import React, { useEffect } from 'react';
import { FiX } from 'react-icons/fi';
import { Button } from './ui';
import { Container } from './ui/container';

interface ModalProps extends React.ComponentPropsWithoutRef<'div'> {
	isOpen: boolean;
	onClose: () => void;
	children: React.ReactNode;
	closeOnOutsideClick?: boolean;
	closable?: boolean; // New prop
}

// Global counter for open modals
let openModalCount = 0;

const Modal: React.FC<ModalProps> = ({
	isOpen,
	onClose,
	children,
	closeOnOutsideClick = true,
	closable = true, // Default to true
	...props
}) => {
	useEffect(() => {
		if (isOpen) {
			openModalCount++;
			if (openModalCount === 1) {
				document.body.classList.add('modal-open');
			}
		}
		return () => {
			if (isOpen) {
				openModalCount = Math.max(0, openModalCount - 1);
				if (openModalCount === 0) {
					document.body.classList.remove('modal-open');
				}
			}
		};
	}, [isOpen]);

	if (!isOpen) return null;

	const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
		e.stopPropagation();
		if (closeOnOutsideClick) {
			onClose();
		}
	};

	const handleModalClick = (e: React.MouseEvent<HTMLDivElement>) => {
		e.stopPropagation();
	};

	return (
		<div
			className={`fixed inset-0 z-50 flex items-center justify-center bg-foreground/45 backdrop-blur-sm transition-all`}
			onClick={closable ? handleOverlayClick : () => undefined}
		>
			<div className={`${props.className} relative w-full max-w-xl p-4 transition-all`} onClick={handleModalClick}>
				<Container contentClassName="p-0!" className="relative flex flex-col items-center border-[3px] !bg-background/85 shadow-2xl transition-all">
					{closable && (
						<Button onClick={onClose} className="absolute right-4 top-4 z-10 bg-background/35 p-2  hover:bg-inverted-foreground/90">
							<FiX size={16} />
						</Button>
					)}
					{children}
				</Container>
			</div>
		</div>
	);
};

export default Modal;
